// M12 - MotricityBarPerPhase
//
// Bar chart generico para mostrar una metrica por fase de un juego.
// El consumidor pasa el array de fases ya normalizado: [{ index, value }].

import React, { useMemo } from "react";
import { Card } from "antd";
import { Column } from "@ant-design/charts";

export function MotricityBarPerPhase({
  title,
  data,
  yLabel = "Valor",
  height = 240,
  color = "#ed773c",
}) {
  const dataNormalized = useMemo(
    () =>
      (data || []).map((d) => ({
        phase: `Fase ${d.index}`,
        value: Number(d.value) || 0,
      })),
    [data],
  );

  const config = useMemo(
    () => ({
      data: dataNormalized,
      xField: "phase",
      yField: "value",
      height,
      color,
      autoFit: true,
      label: {
        position: "top",
        style: { fontSize: 11, fontWeight: 600 },
      },
      axis: {
        x: { title: false },
        y: { title: yLabel },
      },
    }),
    [dataNormalized, color, height, yLabel],
  );

  return (
    <Card title={title} variant="outlined">
      <Column {...config} />
    </Card>
  );
}
